import { Address } from "../../models";

export const DEFAULT_ADDRESS: Address = {
  countyId: undefined,
  county: "",
  municipalityId: undefined,
  municipality: "",
  town: "",
  townId: undefined,
  street: "",
  streetId: undefined,
  houseNumber: "",
  houseNumberId: undefined,
};
